import { v4 as uuidv4 } from 'uuid';

/**
 * UUID v4 generator for POS config pages/tiles.
 *
 * Replaces the legacy AngularJS `uuid2.newuuid()` (angular-uuid2) dependency
 * with the `uuid` package already used elsewhere in the repo (e.g.
 * cart.service.utils.ts). Both produce RFC-4122 v4 UUIDs and the value is an
 * opaque page/tile id.
 */
export function newUuid(): string {
  return uuidv4();
}
